import styled from "styled-components";
import { Paragraph, Heading } from "../../atoms/Typography/Typography.styles";

interface CardCertificationsProps {
    colorScheme: string;
    withBackground?: boolean;
}

export const CardCertifications = styled.div<CardCertificationsProps>`

`

export const CardCertificationsContent = styled.div<CardCertificationsProps>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${Heading} {
    margin-bottom: ${({ theme }) => theme.rem(16)};
  }

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, withBackground, colorScheme }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'}!important;
  }
`

